export const capitalize = (text: string): string => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const camelCaseToSeparateWords = (text: string): string => {
  if (!text) return "";
  return text.replace(/[A-Z]/g, (letter) => ` ${letter}`);
};
